import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import nameof from '../../utils/nameof';
import { renderNewTextField, renderErrorInfoText, renderMultilineTextField, renderSelectWithTextLabel } from '../../common/forms/FieldCreators';
import { FormGroup } from '../../common/forms/FormGroup';
import FormItem from '../../components/forms/FormItem';
import { OnSubmitFormProps } from '../../common/props/commonFormProps';
import { Form, Control, Errors } from 'react-redux-form';
import { RegisterCompanyModel } from './RegisterCompanyModels';
import { AddressFormGroup } from '../../common/forms/AddressFormGroup';
import { ContactFormGroup } from '../../common/forms/ContactFormGroup';
import { localizations } from '../../localization/localization';
import * as validators from '../../common/validators/formValidators'
import MenuItem from '@material-ui/core/MenuItem';
import { CompanyIndustryTypeOptions } from '../../common/models/CommonModels';


interface RegisterCompanyFormState {
    stepIndex: number;
}

type RegisterCompanyFormProps = OnSubmitFormProps<any>

class RegisterCompanyForm extends React.Component<RegisterCompanyFormProps, RegisterCompanyFormState> {
    
    public render() {
        const { onSubmit } = this.props;

        return (
            <div>
                <Typography variant="body2">{localizations.register.registerCompanyStepOne}</Typography>
                <Form hideNativeErrors  onSubmit={onSubmit} model="registerCompanyModel">
                    <FormGroup>
                        <FormItem>
                            <Control required validators={{ required: validators.required }} validateOn={["blur", "change"]} model={`.${nameof<RegisterCompanyModel>("name")}`} label={localizations.common.companyName} component={renderNewTextField} />
                            <Errors model={`.${nameof("name")}`} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                        </FormItem>
                        <FormItem>
                            <Control required validators={{ isBusinessID: validators.isBusinessID }} validateOn={["blur", "change"]} model={`.${nameof<RegisterCompanyModel>("businessId")}`} label={localizations.common.businessId} component={renderNewTextField} />
                            <Errors model={`.${nameof("businessId")}`} show={{ touched: true, focus: false }} messages={{ isBusinessID: localizations.validation.notABusinessID }} wrapper={renderErrorInfoText} />
                        </FormItem>
                        <AddressFormGroup />
                    </FormGroup>
                    <ContactFormGroup />
                    <FormGroup>
                        <FormItem><Control model={`.${nameof<RegisterCompanyModel>("website")}`} label={localizations.common.website} component={renderNewTextField} /></FormItem>
                        <Grid item style={{ textAlign: "left"}}>
                            <FormItem>
                                <Control.text 
                                    required
                                    validators={{ required: validators.required }}
                                    style={{ minWidth: 120 }}
                                    label={localizations.company.companyIndustryType}
                                    model=".industryType" 
                                    component={renderSelectWithTextLabel} 
                                    id="industryType-select"
                                    >
                                    {CompanyIndustryTypeOptions(localizations).map((opt: any) => <MenuItem key={opt.label} value={opt.value}>{opt.label}</MenuItem>)}
                                </Control.text>
                                <Errors model={".industryType"} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                            </FormItem>
                        </Grid>
                        <FormItem>
                            <Control.text
                                model={`.${nameof<RegisterCompanyModel>("description")}`}
                                component={renderMultilineTextField} 
                                label={localizations.company.companyDescription}
                                controlProps={{rows: 5, placeholder: localizations.settings.companyDescription}}
                                validators={{isValidLength: this.validateLength}}
                            />
                            <Errors
                                model={".description"}
                                messages={{
                                    isValidLength: localizations.validation.maxLength200
                                }}
                                show={{touched: true, focus: false }}
                                wrapper={renderErrorInfoText}
                            />
                        </FormItem>
                    </FormGroup>
                    <br />
                    <FormItem>
                        <Grid container direction="row" spacing={4} justify="center">
                            <Grid item><Button variant="contained" color="secondary" type="reset">{localizations.actions.reset}</Button></Grid>
                            <Grid item><Button variant="contained" type="submit" color="primary">{localizations.actions.continue}</Button></Grid>
                        </Grid>
                    </FormItem>
                </Form>
            </div>
        );
    };

    private validateLength = (value: any) => {
        return validators.isLengthValid(value, 200);
    }
};

export default RegisterCompanyForm;



// WEBPACK FOOTER //
// ./src/register/company/RegisterCompanyForm.tsx